export var MAKE_QUICKBET = 'MAKE_BET';
export var SUCCESS_MAKE_QUICKBET = 'SUCCESS_MAKE_QUICKBET';
export var FAILURE_MAKE_QUICKBET = 'FAILURE_MAKE_QUICKBET';
export var MAKE_BET = 'MAKE_BET';
export var SUCCESS_MAKE_BET = 'SUCCESS_MAKE_BET';
export var FAILURE_MAKE_BET = 'FAILURE_MAKE_BET';
export var MAKE_MULTI_SINGLE_BET = 'MAKE_MULTI_SINGLE_BET';
export var SUCCESS_MAKE_MULTI_SINGLE_BET = 'SUCCESS_MAKE_MULTI_SINGLE_BET';
export var FAILURE_MAKE_MULTI_SINGLE_BET = 'FAILURE_MAKE_MULTI_SINGLE_BET';



// WEBPACK FOOTER //
// ./src/actions/makeBet.js